module.exports = __webpack_public_path__ + "static/media/lesson_chapter_4.99e1094c.png";